var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h5',[_c('router-link',{attrs:{"to":{ name: 'Layer', params: { uuid: _vm.feature.layer.id } }}},[_vm._v("\n      "+_vm._s(_vm.feature.layer.name)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("»")])],1),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.feature.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eaac46c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feature/BreadcrumbHeader.vue
// module id = null
// module chunks = 